import { SubjectType } from './focal-area.model';
import { PreviewMode } from './focal-area-state.model';

export const SUBJECT_TYPE_LABELS: Record<SubjectType, string> = {
	[SubjectType.Person]: 'Person',
	[SubjectType.Product]: 'Product',
	[SubjectType.Text]: 'Text',
	[SubjectType.Logo]: 'Logo',
	[SubjectType.Scene]: 'Scene',
	[SubjectType.Other]: 'Other'
};

export const DEFAULT_ASPECT_RATIOS = [
	{ label: 'Square (1:1)', value: '1:1', mode: PreviewMode.Square },
	{ label: 'Landscape (16:9)', value: '16:9', mode: PreviewMode.Landscape16x9 },
	{ label: 'Portrait (9:16)', value: '9:16', mode: PreviewMode.Portrait9x16 },
	{ label: 'Landscape (4:3)', value: '4:3', mode: PreviewMode.Landscape4x3 },
	{ label: 'Portrait (3:4)', value: '3:4', mode: PreviewMode.Portrait3x4 }
];

export const DEFAULT_FOCAL_AREA = {
	name: 'New Focal Area',
	subjectType: SubjectType.Scene,
	areaType: 'Primary Subject',
	cropMode: 'contain' as const,
	aspectPriority: 'crop' as const,
	boundingBox: { x: 25, y: 25, width: 50, height: 50 },
	aspectRatio: '16:9',
	isDefault: false,
	tags: [] as string[]
};

export const AREA_TYPE_OPTIONS = [
	'Primary Subject',
	'Secondary Subject',
	'Background',
	'Text Area',
	'Logo Area',
	'General'
];

export const CROP_MODE_OPTIONS = [
	{ label: 'Cover', value: 'cover' },
	{ label: 'Contain', value: 'contain' }
];
